export default __webpack_public_path__ + "static/media/p1-9.d801d3d9.png";